<template>
	<div class="modal-info">
		<!-- INICIO MODAL -->
		<modal v-if="modalVisible" @close="closeModal()">
			<div slot="header">
				<div class="tit">
					<h2>{{ selectedItem.Impacto.NomeEmpresa }}</h2>
					<span>{{ selectedItem.Nome }} – {{ selectedItem.Impacto.Cidade }} / {{ selectedItem.Impacto.UF }}</span>
					<small><strong>ID#{{ ajustIdOportunidade(selectedItem.IdOportunidade, 5) }}</strong></small>
				</div>
			</div>
			<div slot="body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="box">
							<label>Valor solicitado</label>
							<p>R$ {{ formatCurrency(selectedItem.Valor) }}</p>
						</div>
					</div>
					<div class="col-12 col-md-6">
						<div class="box">
							<label>Duração</label>
							<p>{{ selectedItem.Prazo }} meses</p>
						</div>
					</div>
				</div>

				<div class="row items">
					<div class="col-12 col-md-6 col-lg-6">
						<div class="item">
							<div class="clearfix">
						      	<span class="float-left item__info">Levantado: {{ formatCurrency(selectedItem.ValorCaptado) }}</span>
						      	<span class="float-right item__info">Faltam: <strong>R$ {{ formatCurrency(calcValorRestante(selectedItem)) }}</strong></span>
						  	</div>
						  	<div class="progress">
						      	<div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" :style="'width:' + selectedItem.PercValorRestante + '%'">
						          	<span class="progress-value">{{ formatCurrency(selectedItem.PercValorRestante) }}%</span>
						      	</div>
						  	</div>
						  	<div class="itens">
						      	<p>Início da captação: <strong>{{ dataLonga(selectedItem.InicioCaptacao )}}</strong></p>
						      	<p>Expira: <strong>{{ dataLonga(selectedItem.FimCaptacao )}}</strong></p>
						  	</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-6">
						<div class="item">
							<form> 
								<div v-if="canInvest && !InvestidorBloqueado()" class="form-row">
									<div v-if="!selectedItem.JaInvestiu && showInputInvestment" class="col-12 col-md-8">
										<label for="exampleFormControlInput1">Valor que deseja aportar</label>
										<input v-model="valorInv" v-mask="'money'" type="text" class="form-control form-control-lg" id="exampleFormControlInput1" :placeholder="'Invest. Mínimo R$ '+formatCurrency(selectedItem.InvestimentoMinimo)">
									</div>
									<div v-if="!selectedItem.JaInvestiu && showInputInvestment" class="col-12 col-md-4 d-flex align-items-end">
										<button type="button" class="btn btn-lg btn-primary btn-block" @click="ShowSaldo()">Investir</button>
									</div>
									<!--REINVESTIMENTO-->
									<div v-if="showInputSaldo" class="form-row">
										<div class="col-12">
											<div class="row">
												<div class="reinvestir">
														<div class="col-12 d-flex align-items-center">
														<img src="/static/assets/images/ico-reinvestir.svg" alt="icone reinvestir">
														<p>{{Nome()}}, você possuí saldo em sua Carteira virtual. Gostaria de reinvestir o seu saldo?</p>
													</div>
													<div class="col-12 d-flex">
														<span>Total disponível para reinvestir: <strong>R$ {{formatCurrency(sDisponivel||0.00)}}</strong></span>
													</div>					
												</div>
											</div>
										</div>
										<div class="col-12 col-md-7 col-xl-8">
											<label for="exampleFormControlInput2">Valor que deseja utilizar</label>
											<input id="exampleFormControlInput2" v-model="valorReinvestimento" type="text" class="form-control form-control-lg" placeholder="R$ 1.500,00" v-mask="'money'">
										</div>
										<div class="col-12 col-md-5 col-xl-4 d-flex align-items-end">
											<button class="btn btn-primary btn-lg btn-block"  @click.prevent="UsarSaldo()">Usar saldo</button>
										</div>
										<a href="#" @click.prevent="NaoUsarSaldo()" class="btn btn-link">Não utilizar saldo disponível.</a>
										<!-- Esse paragrafo aparece apenas quando houver erro de valor informado -->
										<p class="small">O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.</p>
									</div>
									<div v-if="selectedItem.JaInvestiu" style="width: 100%">
										<div class="alert alert_reserve alert-warning text-center" style="width: 100%">
											<h2>Você já efetuou um aporte para este investimento.</h2>
										</div>
									</div>
								</div>
								<div v-else class="form-row">
									<div class="alert alert_reserve alert-warning text-center" style="width: 100%">
										<h2 v-if="InvestidorBloqueado()">Cadastro Bloqueado</h2>
										<h2 v-else>Falta pouco para você investir</h2>

										<div>
											<p v-if="InvestidorBloqueado()">
												Perfil bloqueado, favor retornar após {{$store.state.currentUser.investor.Bloqueio.Dias}} dias.
											</p>
											<p v-else-if="temCadastroInvestidor && temSuitability && !investidorAprovado" style="font-size: 20px;">Agora estamos analisando suas informações e retornaremos em até 1 dia útil.</p>
											<p v-else>
												<router-link v-if="!temCadastroInvestidor" to="/informacoes-adicionais/investidor" class="btn btn-link">Complete o cadastro de investidor</router-link>
												<router-link v-if="!temSuitability" to="/informacoes-adicionais/suitability" class="btn btn-link">Preencha o formulário de suitability</router-link>
											</p>
										</div>
									</div>
								</div>
							</form>
							<div class="confirm" v-if="!(canInvest && !InvestidorBloqueado()) && investmentConfirmed">
								<img src="/static/assets/images/ico-confirm.svg" class="float-left" alt="icone de confirmação">
								<p>
									Investimento registrado com sucesso.<br>
									<small>Assim que o valor atingir 100% captado, você vai receber as instruções por e-mail e basta seguir os passos informados.</small>
								</p>
							</div>
							<router-link v-if="!InvestidorBloqueado()" :to="'/investimentos/investimento-de-impacto/perfil-impacto/' + selectedItem._id" class="item__link" title="Exibir perfil detalhado">Exibir perfil detalhado <i>&nbsp;</i></router-link>
						</div>
					</div>
				</div>
			</div>
		</modal>
		<!-- FINAL MODAL -->

		<!-- INICIO MODAL -->
		<modal v-if="modalInfoAdicional" @close="closeModal()">
			<div slot="header">
				<div class="tit">
					<h2>Informações Adicionais</h2>
				</div>
			</div>
			<div v-if="!finalizado" slot="body">
				<div class="tit">
					<h4>Deseja exibir o seu nome na lista de investidores?</h4>
				</div>
				<div class="form-row">
					<div class="form-check form-check-inline d-flex">
						<input class="" type="radio" name="anonimo" v-model="anonimo" :value="false" required>
						<label class="form-check-label" style="padding-left: 0px; font-weight: normal;">Sim. Desejo exibir o meu nome na lista de investidores.</label>
					</div>
				</div>
				<div class="form-row">
					<div class="form-check form-check-inline d-flex">
						<input class="" type="radio" name="anonimo" v-model="anonimo" :value="true" required>
						<label class="form-check-label" style="padding-left: 0px; font-weight: normal;">Não. Desejo estar presente na lista de investidores somente como <strong>anônimo</strong>.</label>
					</div>
				</div>
				<br>
				<div class="tit">
					<h4>Deseja exibir a quantia do seu aporte na lista de investidores?</h4>
				</div>
				<div class="form-row">
					<div class="form-check form-check-inline d-flex">
						<input class="" type="checkbox" name="anonimo" v-model="exibirQuantia" required>
						<label class="form-check-label" style="padding-left: 0px; font-weight: normal;">Sim. Desejo exibir a quantia do meu aporte na lista de investidores.</label>
					</div>
				</div>
				<br>
				<div class="form-row">
					<button class="btn btn-primary btn-lg" style="background-color: #40CD28; border-color: #40CD28;" @click="apoiar(selectedItem._id, valorInv)">Finalizar</button>
				</div>
			</div>
			<div v-else slot="body" class="success d-flex flex-column justify-content-center align-items-center">
				<i class="icon icon-success xll"></i>
				<h3>Aporte realizado com sucesso!</h3>
				<br />
				Por favor, verifique no seu e-mail o boleto para pagamento do aporte realizado.
			</div>
		</modal>
		<!-- FINAL MODAL -->

		<div v-if="!emBreveNovosInvestimentosImpacto" class="row list-view">
			<div class="col-12 tit_page">
				<div class="row">
					<div class="col-12 col-lg-6 float-left">
						<h1>Investimentos sociais</h1>
					</div>
					<div class="clearfix"></div>
				</div>

				<hr class="divider">

				<ul v-if="response" class="row">
					<li v-for="(impact, index) in listImpacts" v-bind:key="impact._id" class="col-12 col-md-4 col-lg-3">
						<div class="item-card">
							<figure>
								<router-link :to="'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id"><img class="card-img-top" :src="impact.Impacto != null ?impact.Impacto.ImagemLista:''" alt="Card image cap"></router-link>
								<label>
									<span>{{ impact.Impacto.Categoria != null ? impact.Impacto.Categoria.toUpperCase() : '' }}</span>
								</label>
							</figure>
							<div class="card-body text-center">
								<h5 class="card-title">{{ impact.Impacto.TituloCampanha }}</h5>
								<small class="text-muted">{{ impact.Impacto.Cidade }} / {{ impact.Impacto.UF }}</small>
								<hr class="divider">
								<!-- <p class="card-text">{{ impact.Impacto.InformacaoResumida }}</p> -->
								<span class="info-invest">
									<strong>{{ listImpacts[index].QuantidadeReservasInvestimento }}</strong> Investidores
								</span>
								<div class="item-progress">
									<p>
										<span class="text-muted">Valor levantado</span>
										R$ {{ formatCurrency(listImpacts[index].ValorCaptado) }}
									</p>
									<div class="progress">
										<div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" :style="'width:' + listImpacts[index].PercValorRestante  + '%'">
											<span class="progress-value">
												{{ formatCurrency(listImpacts[index].PercValorRestante) }}%
											</span>
										</div>
									</div>
									<small class="text-muted">Faltam: <strong>R$ {{ formatCurrency(listImpacts[index].ValorRestante) }}</strong></small>
								</div>
								<!-- <a v-if="listImpacts[index].PermiteAporte" id="show-modal" @click="showModal(impact)" class="btn btn-primary" title="Apoiar">Apoiar</a> -->
								<div>
									<span class="text-muted">Rendimento</span>
									<p>{{ formatCurrency(listImpacts[index].TaxaJuros) }}% a.m.</p>
								</div>
							
								<router-link v-if="listImpacts[index].PermiteAporte" id="show-modal" :to="'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id" class="btn btn-primary" title="Apoiar">Investir</router-link>
								<a v-else id="show-modal" class="btn btn-primary" title="Apoiar" style="background-color: gray;">Encerrado</a>								
								<router-link v-if="!InvestidorBloqueado()" :to="'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id" class="btn btn-link" title="Exibir detalhes">Exibir detalhes</router-link>
							</div>
						</div>
					</li>
				</ul>

			</div>
		</div>

		<div v-else class="d-flex justify-content-center align-items-center dashboard">
			<div class="dashboard__complete">
				<div class="row">
					<div class="col-12 text-center">
						<h1>Em breve novos investimentos sociais</h1>
					</div>
				</div>
			</div>
     	</div>
	</div>
</template>
<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

	ul {
		margin-bottom: 0px;
	}

	.modal-header {
		.tit {
			border:none;
			margin:0px;
			padding:0px;
		}
	}
	
	.modal-body {
		.box {
			label {
				@include font-size(13px);
				line-height: 15px;
				padding:0px;
				margin:0px;
				color: #999;
			}

			p {
				color: $black;
			}

			input {
				margin-bottom: 0px;
			}
		}
		.btn {
			&-link {
			@include font-size(14px);
				padding: 10px 5px 0 5px;
			}
		}
	}

	.item-card {
		border: 1px solid #ddd;
		border-radius: 5px;
		display: block;
		margin: 15px 0;

		figure {
			position: relative;

			label {
				background:url(/static/assets/images/bg-label.png) no-repeat;
				padding:0px;
				margin:0px;
				position:absolute;
				left: -5px;
				bottom: -20px;
				height: 45px;
				left: -5px;

				span {
					color: #fff;
					display:block;
					padding: 14px 25px 0 25px;
					text-transform: uppercase;
					@include font-size(13px);
				}
			}
		}

		h5 {
			@include font-size(18px);
			margin-top: 10px;
			margin-bottom: 0;
		}

		.card-text {
			color: #000;
			line-height: 18px;
			height: 60px;
			padding-bottom: 0px;
			margin-bottom: 5px;


			@include ds {
				margin-bottom: 40px;
			}

			@include xs {
				@include font-size(12px);
				@include line-height(14px);
				min-height:70px;
			}
		}
	}

	.info-invest {
		line-height: 25px;
		background: url(/static/assets/images/ico_investidores.svg) no-repeat;
		background-size: 25px;
		display: inline-block;
		padding-left: 30px;
		margin: 5px 0;
	}

	.items {
		.margin {
			border-right: 1px solid #ddd;
			padding-right: 30px;
		}

		.item {
			border-bottom: 1px solid #ddd;
			&__info {
				color: #888;
				@include font-size(16px);
				strong {
					color: #000;
				}
			}

		span {
			margin: 0;
			padding: 0;
		}

		&:first-child {
			padding-top: 0px;
		}

		&:last-child {
			border-bottom: none;
			padding-bottom: 0px;
		}

		p {
			padding: 0px;
			margin: 0px;
			color: #888;
			strong {
				color: #000;
			}
		}

		.progress {
			margin: 10px 0;
		}

		.small {
			font-size: 13px;
			color: #888;
			margin: 0px;
			padding: 0px;
		}

		.alert {
			h2 {
				color: #856404!important;
				padding:0 0 5px 0;
			}
			p {
				padding:0px!important;
			}
			.btn {
				&-link {
					margin-top:0px;
					padding:5px;
				}
				
			}
			a:hover {
				color: #856404;
			}
		}

		form {
			margin-bottom: 10px;
		
			label {
				@include font-size(13px);
				padding-bottom:0px;
				margin:0px;
			}

			button {
				&.btn-primary {
					text-transform: uppercase;
					font-weight:bold;
					background-color: #40CD28;
					color: $white;
					border:none;

					&:hover {
						color: $white;
						background-color: #39b824;
					}
				}
			}
		}

		.confirm {
			margin: 20px 0;
			img {
				width: 40px;
				display: block;
				margin-top: 6px;
				margin-right: 10px;
			}

			p {
				display: table;
				a {
				color: #888;
				text-decoration: underline !important;
				font-weight: bold;
				&:hover {
					color: #666;
				}
				}
			}
		}

		a {
			&.item__link {
				float: left;
				@include font-size(22px);
				line-height: 30px;
				color: #888;
				position: relative;

				&:hover {
					color: $c3;
				}

				@include xs {
					@include font-size(18px);
				}
			}

			i {
				background: url(/static/assets/images/ico-separador.svg) no-repeat right center;
				background-size: 8px;
				width: 20px;
				line-height: 30px;
				position: absolute;
				top: 0;
				right: -20px;

				@include xs {
					background-size: 6px;
					width: 18px;
					line-height: 30px;
				}
			}
		}

			.form-row {
			label {
				color: #000 !important;
				padding-bottom: 10px;
			}

			input {
				margin-bottom: 0px;
				box-shadow: none !important;
				height: 50px;
			}

			button {
				height: 50px;
				@include font-size(18px);
			}
			}
		}
	}
	.item-progress {
		margin-bottom: 10px;
		p {
			@include font-size(24px);
			font-weight:bold;
			color: #000;
			line-height: 24px;

			span {
				display:block;
				@include font-size(14px);
			}
		}
	}

	a {
		&.btn-primary {
			text-transform: uppercase;
			font-weight:bold;
			padding-left: 30px;
			padding-right: 30px;
			background-color: #40CD28;
			color: $white;
			border:none;

			&:hover {
				color: $white;
				background-color: #39b824;
			}
		}

		&.btn-link {
			display: block;
			color: #666;
			
			&:hover {
				color: #333;
			}
		}
	}


	@include ds {
		.tit {

			h2 {
				font-size: 18px!important;
			}
			small {
				font-size: 12px !important;
				padding-top: 5px;
			}
		}

		.box {
			padding: 10px;
		}

		.items {
			.item {
				padding: 10px 0;

				.small {
					font-size: 10px;
				}

				&__info {
					@include font-size(10px);
				}

				a {
					&.item__link {
						@include font-size(14px);
						line-height: 20px;
					}
					i {
						background-size: 5px;
						width: 11px;
						line-height: 20px;
						top: 0;
						right: -15px;
					}
				}

				label {
					font-size: 9px!important;
					padding-bottom: 5px;
				}


				.form-row {
					input {
						@include font-size(16px);
						height: 40px;
					}
					button {
						height: 40px;
						@include font-size(14px);
					}
				}

				.alert {
					h2 {
						background:none;
						padding:0px;
						font-size: 18px;
					}
					p {
						padding-bottom: 10px;
					}
					.btn {
						width: 80%!important;
						margin: 0 10%;
					}
				}
			}
		}
	}
</style>

<script>
/* eslint-disable */
	import Modal from "@/components/Modal";
	import Masker from '@/utils/masker';
	import ApiClient from '../utils/api-client';
	import ArrayHelper from "@/utils/array-helper";
	import * as mutationTypes from '@/store/mutation-types.js'

	export default {
		data() {
			return {
				investmentConfirmed: false,
				modalVisible: false,
				response: false,
				modalInfoAdicional: false,
				exibirQuantia: true,
				anonimo: false,
				finalizado: false,
				temCadastroInvestidor: false,
				temSuitability: false,
				investidorAprovado: false,
				emBreveNovosInvestimentosImpacto: false,
				qtdeInvestidores: 0,
				index: 0,
				listImpacts: {},
				selectedItem: {},
				sDisponivel : 0,
				showInputInvestment: true,
				showInputSaldo: false,
				valorReinvestimento : 0,
				valorInv :0
			};
		},

		computed: {
			canInvest() {
				return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
			},
			User: function() {
				return this.$store.state.currentUser;
			},
		},

		methods: {
			OpenModal(isAbrir) {
				this.showModal = isAbrir;

				if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";
				else document.getElementsByTagName("main")[0].style.zIndex = "0";
			},

			calcValorRestante(impact) {
				
				return impact.Valor - impact.ValorCaptado;
			},

			calcPercValorRestante(impact) {
				return impact.ValorCaptado * 100 / impact.Valor;
			},

			formatCurrency(value) {
				if(!value) value = 0;
				return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
			},

			countInvestor(index, solicitacaoId) {
				ApiClient.getCountLoanImpactInvestors(solicitacaoId).then((response) => {
					this.listImpacts[index].QtdeInvestidores = response.data;
					this.$forceUpdate();
				});
			},

			showModal(item) {

				if(document.getElementsByTagName("main").length > 0 ){
							document.getElementsByTagName("main")[0].style.zIndex = "50";
				}
				this.selectedItem = item;
				this.valorInv = item.ReservaInvestimento.Valor;
				this.modalVisible = true;
				this.modalInfoAdicional = false;
				this.showInputSaldo = false;
				this.showInputInvestment= true;
			},

			closeModal() {

				if(document.getElementsByTagName("main").length > 0 ){
				   document.getElementsByTagName("main")[0].style.zIndex = "0";
				}

				this.modalVisible = false;
				this.modalInfoAdicional = false;
				this.finalizado = false;
				this.showInputSaldo = false;
				this.showInputInvestment= true;
			},

			dataLonga(data) {
				var date = new Date(data);
				date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
				var options = { year: "numeric", month: "long", day: "numeric" };
				return date.toLocaleDateString("pt-BR", options);
			},

			ajustIdOportunidade(id, qtd) {
				var s = String(id);

				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}

				return s;
			},

			getValorCaptado(index, solicitacaoId) {
				ApiClient.getValorCaptadoLoanImpact(solicitacaoId).then(response => {
					if(response.data.length > 0) {
						// this.listImpacts[index].ValorCaptado = response.data[0].Total;
						
						this.listImpacts[index].ValorRestante = this.listImpacts[index].Valor - this.listImpacts[index].ValorCaptado;
						
						
						
						this.listImpacts[index].PercValorRestante = this.listImpacts[index].ValorCaptado * 100 / this.listImpacts[index].Valor;
					}

					this.$forceUpdate();					
				});
			},

			getInvestidor(index, solicitacaoId) {
				ApiClient.getInvestidorLoanImpact(solicitacaoId).then(response => {
					if(response.data != null && response.data.Status != 0) {
						this.listImpacts[index].JaInvestiu = true;

						this.listImpacts[index].ReservaInvestimento = response.data;
						this.listImpacts[index].ReservaInvestimento.Valor += ",00";
					} else {
						this.listImpacts[index].JaInvestiu = false;
					}

					this.$forceUpdate();					
				});
			},

			diffDate(d1, d2) {
				var date1, date2;

				if (d1 == "") {
					date1 = new Date();
				} else {
					date1 = new Date(d1);
					date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
				}

				if (d2 == "") {
					date2 = new Date();
				} else {
					date2 = new Date(d2);
					date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
				}


				var timeDiff = date2.getTime() - date1.getTime();
				var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

				if (diffDays < 0) return "Encerrado";
				if (diffDays == 0) return "Finaliza hoje*";

				return "Finaliza em " + diffDays + " dias*";
			},

			ShowSaldo(){

				if(!this.ValidarInvestimento())
				{
					return false;
				}

				var value = 0
				if (typeof this.valueToInvest === 'string') {
					var inv = this.valueToInvest.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv / 100);
				}

				if(this.sDisponivel > 0)
				{
					if(this.sDisponivel > value)
					{
						this.valorReinvestimento = this.money(value || 0)
					}
					else
					{
						this.valorReinvestimento = this.money(this.sDisponivel || 0)
					}
					
					this.showInputInvestment = false;
					this.showInputSaldo = true;
					return true;
				}

				this.proximoPasso();
				return true;
			},
			InvestidorBloqueado() {
		
				if(this.$store.state.currentUser == null || this.$store.state.currentUser.investor == null|| this.$store.state.currentUser.investor.Bloqueio == null || this.$store.state.currentUser.investor.Bloqueio.FimBloqueio == null)
					return false;

				var FimBloqueio= new Date(this.$store.state.currentUser.investor.Bloqueio.FimBloqueio)
				
				return (FimBloqueio > (new Date()));
			},
			NaoUsarSaldo(){

			
					this.valorReinvestimento = 0;
					this.proximoPasso();
			
				return false;
			},
			ValidarInvestimento(){

				var value = 0
				if( typeof this.valorInv === 'string')
				{
					var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv/100);
				}

				if(value == 0 || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "Por favor, insira um valor."
					});

					return false;
				}

				if(value < 100 || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor mínimo de aporte é de R$ 100,00."
					});

					return false;
				}

				if((value % 100 != 0) || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor deve ser multiplo de R$ 100."
					});

					return false;
				}

				if (value > this.selectedItem.Valor ) {
						this.$Notify.error({
							title: "Desculpe",
							message: "O valor de aporte é maior que o solicitado."
						});

						return false;
				}

				if( ((this.selectedItem.Valor - this.selectedItem.ValorCaptado) > 0) &&   value > (this.selectedItem.Valor - this.selectedItem.ValorCaptado)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor de aporte é maior que o disponível."
					}); 

					return false;
				}

				return true;

			},
			UsarSaldo(){


			    var valor = 0;

				if( typeof this.valorReinvestimento === 'string')
				{
					var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
					valor = parseFloat(reInv/100);
				}

				var errorMessages;

				if(valor < 0 ){

					errorMessages = ["Insira um valor para o reinvestimento."]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));

					return false;
				}

				if(valor> this.sDisponivel){

					errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));

					return false;
				}

				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				var valorInv = parseFloat(inv)/100;

					
				if(valor > valorInv){

					errorMessages = ["O valor deve ser menor ou igual ao investido : R$ " + this.formatCurrency(valorInv)]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));

					return false;
				}


				this.proximoPasso()
				return false;
			},

			proximoPasso() {
				this.closeModal();
				this.modalInfoAdicional = true;

				if(document.getElementsByTagName("main").length > 0 ){
							document.getElementsByTagName("main")[0].style.zIndex = "50";
				}
			},

			apoiar(solicitacaoId, valueToInvest) {
				
				this.closeModal();
				this.modalInfoAdicional = true;

				if(document.getElementsByTagName("main").length > 0 ){
							document.getElementsByTagName("main")[0].style.zIndex = "50";
				}

				var value = 0
				if( typeof this.valorInv === 'string')
				{
					var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv/100);
				}


				var valor = 0
				if( typeof this.valorReinvestimento === 'string')
				{
					var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
					valor = parseFloat(reInv/100);

					if (valor > value){
							valor = value;
					}
				}
		
				ApiClient.postApoiarLoanImpact(solicitacaoId, value, valor, this.anonimo, this.exibirQuantia).then(() => {
					this.finalizado = true;

					setTimeout(() => {
						this.get();
					}, 500);
				});
			},

			validaStatusInvestimento(index) {
				var resultDt = this.diffDate(new Date(), this.listImpacts[index].FimCaptacao);

				if (resultDt == "ENCERRADO" || this.listImpacts[index].ValorCaptado >= this.listImpacts[index].Valor)
					return false;

				return true;
			},
			Nome() {
					var nome = "";
					
					if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
					nome = this.User.username;
					} else {
					nome = this.User.name;
					}
					nome = nome.trim();
					var primeiroNome = nome.split(" ")[0];
					return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
				},
			AtualizarSaldo() {
				ApiClient.getMyAvalibleMoney()
					.then(item => {

						item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
						var credito =  parseFloat(item.data.credito) ;

						item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
						var debito =  parseFloat(item.data.debito) ;

						this.sDisponivel = credito - debito;
						this.sDisponivel = parseFloat(this.sDisponivel.toFixed(2));

						if(this.sDisponivel < 0.01)
						{
							this.sDisponivel = 0;
						}

						
					});
				},
			
			get() {
				ApiClient.getLoanImpact().then((response) => {
					this.listImpacts = response.data;

					if(this.listImpacts.length > 0) {
						for(var i = 0; i < this.listImpacts.length; i++) {
							this.listImpacts[i].JaInvestiu = false;
							this.listImpacts[i].PermiteAporte = this.validaStatusInvestimento(i);

							// this.listImpacts[i].QtdeInvestidores = 0;
							// this.listImpacts[i].ValorCaptado = 0;
							this.listImpacts[i].PercValorRestante = 0;
							this.listImpacts[i].ValorRestante = this.listImpacts[i].Valor;
							this.listImpacts[i].ReservaInvestimento = {};
							this.listImpacts[i].ReservaInvestimento.Valor = "";

							this.getInvestidor(i, this.listImpacts[i]._id);
							this.getValorCaptado(i, this.listImpacts[i]._id);
							this.countInvestor(i, this.listImpacts[i]._id);
							
							if(this.listImpacts[i].Impacto == null){
								this.listImpacts[i].Impacto = {}
							}
						}

						this.AtualizarSaldo();

						this.$store.commit(mutationTypes.STOP_LOADING);
					} 

					else {
						this.emBreveNovosInvestimentosImpacto = true;
					}

					this.response = true;									
				});
			},
			//tagueamento GA
			taggingGA() {
				this.$ga.page({
					page: '/investimento-de-impacto/',
					title: 'InvestimentodeImpacto',
				})
			},
		},
		beforeCreated() {
			this.$store.dispatch('updateUser')
		},
		async created() {
			this.temSuitability = this.$store.state.currentUser.hassuitability;
			this.temCadastroInvestidor = this.$store.state.currentUser.hasinvestor;
			this.investidorAprovado = (this.$store.state.currentUser.investor != null && this.$store.state.currentUser.investor.Status == "APROVADO") && this.temCadastroInvestidor;

			this.get();

			//tagueamento GA
			await this.taggingGA();
		},

		watch: {
		},

		components: {
			Modal
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/ListImpact.vue